// extracted by mini-css-extract-plugin
export default {"emphasis":"ProductCount_emphasis__PVqD0","count":"ProductCount_count__8EuEN","productCount":"ProductCount_productCount__tyQvM"};